<template>
  <div>
    <b-table ref="unitMembersTable" id="unit-members-table" striped hover borderless :items="membersList"
      :fields="membersFields" responsive show-empty selectable @row-selected="onMemberRowSelected" class="mt-2"
      thead-class="esep-blue-bg text-light">
      <template #head(selected)="">
        <b-form-checkbox v-model="allMembersSelected" @change="selectAllMembersClick">
        </b-form-checkbox>
      </template>

      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span size="md"> <b-icon icon="person-check-fill"></b-icon> </span>
        </template>
        <template v-else>
          <span size="md"> <b-icon icon="person-check"></b-icon> </span>
        </template>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("excursion.emptyMembersTable") }}</h6>
      </template>

    </b-table>
    <b-row>
      <b-button v-b-modal.modal-prevent-closing @click="addMembers" class="esep-blue-bg ml-3" variant="primary">{{
        $t('common.add') }}</b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  mounted() {
    for (let j = 0; j < this.membersList.length; j++) {
      if (this.preSelected?.map(x => x.id).includes(this.membersList[j].id)) {
        this.$refs.unitMembersTable.selectRow(j);
      }
    }
    this.selectedMembers = this.preSelected;
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    membersList: Array,
    preSelected: Array,
  },
  data() {
    return {
      allMembersSelected: false,
      selectedMembers: [],
      membersFields: [
        { key: "selected", sortable: false },
        { key: 'id', label: "Αριθμός Μητρώου", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'surName', label: "Επώνυμο", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'firstName', label: "Όνομα", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'lastYearCensus', label: "Απογραφή" },
      ],
    }
  },
  methods: {
    onMemberRowSelected(items) {
      this.selectedMembers = items;
    },
    selectAllMembersClick() {
      if (this.allMembersSelected) {
        this.$refs.unitMembersTable.selectAllRows();
      } else {
        this.$refs.unitMembersTable.clearSelected();
      }
    },
    addMembers() {
      this.$emit('selected-members', this.selectedMembers);
    },
  }
}
</script>
